import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ToastNotificationService } from '@shared/services/toast-notification.service';

@Component({
  selector: 'app-toast-container',
  templateUrl: './toast-container.component.html',
  styleUrls: ['./toast-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastContainerComponent {
  toasts$ = this.toastService.toasts$;

  constructor(private toastService: ToastNotificationService) {}

  dismiss(id: number): void {
    this.toastService.dismiss(id);
  }

  trackById(_: number, toast: { id: number }): number {
    return toast.id;
  }
}
